import { PersonalDetailsFields } from 'src/non-financial-data/v2/sections/fields/PersonalDetailsFields';
import IndividualEntityForm from '../IndividualEntityForm';

export default function PersonalDetailsV2() {
  return (
    <IndividualEntityForm title="Personal details">
      <PersonalDetailsFields />
    </IndividualEntityForm>
  );
}
